module.exports = __webpack_public_path__ + "3b87a03c0385bf60ad50a4ff330fc7a7.png";